import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./Style.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import decisionMakerImage from "../../../../Assets/Cloudfigma.svg";
import ContactDetailList from "../../../AiLeads/ContactDetailList/ContactDetailList";
import emptyfile from "../../../../Assets/emptyfile.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import sortingimg from "../../../../Assets/sortingarrow.svg"
import activeSaleforceLogo from "../../../../Assets/activeSaleforceLogo.svg"
function Row({ row }) {


  const getColor = (aiScore) => {
    if (aiScore > 80) {
      return "green";
    } else if (aiScore >= 50 && aiScore <= 80) {
      return "yellow";
    } else {
      return "red";
    }
  };
  const color = getColor(row.ai_score);
  return (
    <React.Fragment>
      <TableRow
        sx={{ "& > *": { borderBottom: "unset" } }}
        className="row-in-prospect-table-aiprofile"
      >
        <TableCell className="Decisions-row-table-new" align="left">
          <div className="Decision-maker-user-name-main-container">
            <div className={`${row?.decision_maker ? 'Decision-maker-user-name' : 'border-change-prospect'}`}>
              <img
                className={
                  row?.suspect_status ? "decisionMakerImage-prospect-details-prospect" : "hide-image"
                }
                // src={decisionMakerImage}
                src={row?.journey_status === "project created" ? activeSaleforceLogo : decisionMakerImage}

                alt=""
              />
              <p className="Front-name">{row?.first_name ? row?.first_name?.substring(0, 1) : ""}{row?.last_name ? row?.last_name?.substring(0, 1) : ""}</p>
            </div>
          </div>
        </TableCell>
        <TableCell className="Decision-maker-userTeblesell" align="left">
          <div className="Decision-maker-user-name-main-container">
            <div>
              <h3 className="company-name-country-prospect-profile">{row?.first_name ? row?.first_name : "-"} {row?.last_name ? row?.last_name : "-"}</h3>


              <div className="job-title-container">
                <div className="tooltip-container-jobtitle">
                  <p className={row?.raw_job_title ? "tooltip-highlights-jobtitle" : "tooltip-highlights-jobtitle-none"}>
                    {row?.raw_job_title}
                  </p>
                  <p className="after-company-name-country-prospect-profile">
                    {row?.primary_job_title?.substring(0, 10) + (row?.primary_job_title?.length > 10 ? "..." : "")}
                  </p>
                </div>
              </div>

              {/* <p className="after-company-name-country-prospect-profile">
                {row?.primary_job_title?.substring(0, 25) + (row?.primary_job_title?.length > 10 ? "..." : "")}</p> */}
            </div>
          </div>
        </TableCell>
        <TableCell align="left">
          <h3 className="annual-revenue-table">{row?.primary_organization ? row?.primary_organization : "-"}</h3>
        </TableCell>
        <TableCell align="left">
          <p className="employee-count">{row?.num_employees ? row?.num_employees : "-"} </p>
        </TableCell>
        <TableCell align="left">
          <p className="employee-count">{row?.revenue_range ? row?.revenue_range : "-"}</p>
        </TableCell>
        {/* <TableCell align="left">
          <h3 className="annual-revenue-table">{row?.employee_size ? row?.employee_size : "-"}</h3>
        </TableCell>
        <TableCell align="left">
          <h3 className="annual-revenue-table">{row?.annual_revenue ? row?.annual_revenue : "-"}</h3>
        </TableCell> */}
        <TableCell
          align="left"
          className="table-cell-of-contact-details-dropdown-thss">
          <ContactDetailList item={row} />
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
Row.propTypes = {
  row: PropTypes.object.isRequired,
};
export default function ProspectProfileTable({
  tableShowResult,
  resultRetrieve,
  fetchMoreData,
  hasMore,
  totalPages,
  setSkip,
  skip,
  showingResult,
  newShowingResult,
  totalCount }) {

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortField, setSortField] = useState(null);

  const loadMore = () => {
    setLoading(true);
    setSkip(skip => skip + 1);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  useEffect(() => {
    setData(resultRetrieve);
  }, [resultRetrieve]);
  const parseEmployeeSize = (size) => {
    const mapping = {
      "1k-5k": "1001-5000",
      "5k-10k": "5001-10000",
      "10k+": "10000+",
      "1K-5K": "1001-5000",
      "5K-10K": "5001-10000",
      "10K+": "10000+",
    };

    const normalizedSize = mapping[size] || size; // Convert shorthand to standard format
    const [min, max] = normalizedSize?.split("-").map((v) =>
      v.toLowerCase().includes("k") || v.toLowerCase().includes("m")
        ? parseInt(v.replace("k", "000").replace("m", "000000"))
        : parseInt(v)
    );

    return { min: min || 0, max: max || Infinity, original: size };
  };

  const sortData = (field) => {
    const newSortOrder = sortOrder === "asc" ? "desc" : "asc";

    const sorted = [...data].sort((a, b) => {
      const sizeA = parseEmployeeSize(a.num_employees);
      const sizeB = parseEmployeeSize(b.num_employees);
      return (sizeA.min - sizeB.min) * (newSortOrder === "asc" ? 1 : -1);
    });

    setSortOrder(newSortOrder);
    setSortField(field);
    setData(sorted);
  };
  // const handleSort = (field) => {
  //   const newSortOrder = sortOrder === "asc" ? "desc" : "asc";
  //   setSortOrder(newSortOrder);
  //   setSortField(field);
  //   const sortedData = [...data].sort((a, b) => {
  //     if (typeof a[field] === "number" && typeof b[field] === "number") {
  //       if (a[field] === b[field]) return a.name.localeCompare(b.name);
  //       return newSortOrder === "asc"
  //         ? a[field] - b[field]
  //         : b[field] - a[field];
  //     }
  //     if (typeof a[field] === "string" && typeof b[field] === "string") {
  //       return newSortOrder === "asc"
  //         ? a[field].localeCompare(b[field])
  //         : b[field].localeCompare(a[field]);
  //     }
  //     return 0;
  //   });
  //   setData(sortedData);
  // };

  const handleSort = (field) => {
    let newSortOrder;
    if (sortField === field) {
      newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    } else {
      newSortOrder = "asc";
    }
    setSortOrder(newSortOrder);
    setSortField(field);

    const employeeOrder = [
      "1-10", "11-50", "51-100", "101-250", "251-500", "501-1000",
      "1K-5K", "5K-10K", "1k-10k", "10K+"
    ];

    const revenueOrder = [
      "$0-$1m", "$0-$1M", "$1m-$10m", "$1M-$10M", "$10m-$50m", "$10M-$50M", "$50m-$100m", "$50M-$100M",
      , "$100m-$500m", "$100M-$500M", "$500m-$1b", "$500M-$1B", "$1b-$10b", "$1B-$10B", "$10b+", "$10B+"
    ];

    const getOrderIndex = (value, orderArray) => {
      const index = orderArray.indexOf(value);
      return index !== -1 ? index : orderArray.length;
    };

    const sortedData = [...data].sort((a, b) => {
      let aValue = field.includes(".")
        ? field.split(".").reduce((acc, key) => acc?.[key], a)
        : a[field];
      let bValue = field.includes(".")
        ? field.split(".").reduce((acc, key) => acc?.[key], b)
        : b[field];

      const isEmpty = (val) => val === null || val === "" || val === "-";
      const aIsEmpty = isEmpty(aValue);
      const bIsEmpty = isEmpty(bValue);

      if (aIsEmpty && !bIsEmpty) return 1;
      if (!aIsEmpty && bIsEmpty) return -1;
      if (aIsEmpty && bIsEmpty) return 0;

      if (field === "updated_at") {
        aValue = new Date(aValue);
        bValue = new Date(bValue);
      }

      if (field === "num_employees") {
        return newSortOrder === "asc"
          ? getOrderIndex(aValue, employeeOrder) - getOrderIndex(bValue, employeeOrder)
          : getOrderIndex(bValue, employeeOrder) - getOrderIndex(aValue, employeeOrder);
      }

      if (field === "revenue_range") {
        return newSortOrder === "asc"
          ? getOrderIndex(aValue, revenueOrder) - getOrderIndex(bValue, revenueOrder)
          : getOrderIndex(bValue, revenueOrder) - getOrderIndex(aValue, revenueOrder);
      }

      if (typeof aValue === "number" && typeof bValue === "number") {
        return newSortOrder === "asc" ? aValue - bValue : bValue - aValue;
      }

      if (typeof aValue === "string" && typeof bValue === "string") {
        return newSortOrder === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      if (aValue instanceof Date && bValue instanceof Date) {
        return newSortOrder === "asc" ? aValue - bValue : bValue - aValue;
      }

      return 0;
    });

    setData(sortedData);
  };

  return (
    <div className="ai-profile-table-main">
      {resultRetrieve?.length ?
        <>
          {/* <InfiniteScroll
            dataLength={resultRetrieve?.length}
            next={() => fetchMoreData()}
            hasMore={hasMore}
            scrollableTarget="DecisionMaker-table-main-profile"
          > */}
          {/* <div className="showing-table-rec"><p>Showing {showingResult + newShowingResult || resultRetrieve.length} Records</p></div> */}
          <div className="showing-table-rec"><p>Showing {totalCount} Records</p></div>
          <TableContainer
            component={Paper}
            className="DecisionMaker-table-main-profile"
          >
            <Table aria-label="collapsible table" className="DecisionMaker-table">
              <TableHead>
                <TableRow className="table-row-ai-leads ">
                  <TableCell className="Decisions-row-table-new-added"> </TableCell>
                  <TableCell className="Decisions-row-table ">
                    <p className="company-classname-prospects-Details"> Name & title{" "}
                      <img src={sortingimg} alt="" className="sorting-arrow-leadsprofile" onClick={() => handleSort("first_name")} />
                    </p></TableCell>
                  {/* <TableCell
                  className="col-1"
                >
                  Score
                </TableCell> */}
                  <TableCell className="Decisions-row-table-company ">
                    <p className="company-classname-prospects">
                      Organization  <img src={sortingimg} alt="" className="sorting-arrow-leadsprofile"
                        onClick={() => handleSort("primary_organization")} /></p>
                  </TableCell>
                  <TableCell className="company-classname-prospects">Employee Size{" "}
                    <img src={sortingimg} alt="" className="sorting-arrow-leadsprofile"
                      onClick={() => handleSort("num_employees")} />
                  </TableCell>
                  <TableCell className="company-classname-prospects">Annual Revenue{" "}
                    <img src={sortingimg} alt="" className="sorting-arrow-leadsprofile" onClick={() => handleSort("revenue_range")} />
                  </TableCell>
                  {/* <TableCell className="Decisions-row-table-company ">
                    <p className="company-classname-prospects">
                    Employee Size</p>
                  </TableCell>
                  <TableCell className="Decisions-row-table-company ">
                    <p className="company-classname-prospects">
                    Annual Revenue</p>
                  </TableCell> */}

                  <TableCell className="Decisions-row-table-detaial ">
                    <p className="Contact-details-prospects-inner-prefilled">
                      Contact details</p>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.map((row, index) => (
                  <React.Fragment key={index}>
                    <Row
                      key={row?.name}
                      row={row}
                    />
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <div className="loadmore-pagination-section">
            {totalPages !== resultRetrieve?.length &&
              <button className="btn-load-more button-loadmore-pagination"
                onClick={loadMore} disabled={loading}>
                {loading ? 'Loading...' : 'Load More'}</button>}
          </div>
          {/* </InfiniteScroll> */}
        </>
        :
        <TableContainer component={Paper} className="aiprofile-table-container">
          <Table aria-label="collapsible table" className="ai-leads-table-empty">
            <TableHead>
              <TableRow className="table-row-ai-leads"></TableRow>
            </TableHead>
            <TableBody>
              <TableRow >
                <TableCell colSpan={4} className="tCell-table-outer-main">
                  <div className="empty-container-div-main">
                    <div className="icon-and-backgroundimage">
                      <div className="empty-icon-div"></div>
                      <div>
                        <img src={emptyfile} alt="" className="empty-icon-image" />
                      </div>
                    </div>
                    <p className="no-result-found-empty">No result for now</p>
                    <p className="add-filter-empty">
                      Please adjust filters to view results
                    </p>
                  </div>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      }
    </div>
    // <>
    // </>
  );
}